import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMapMarkerAlt,
  faEnvelope,
  faStop,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import "../style/Footer.css";
import logowhite from "../images/Lamaan-logo.png";
import logogrey from "../images/logo-grey.png";
import { config } from "../config.js";

const Footer = () => {
  const cleanedNumber = config.number_1.replace(/\s+/g, "");

  return (
    <>
      <footer className="footer-container">
        <div className="footer-section" style={{ backgroundColor: "#142643" }}>
          <h3>Contact Us</h3>
          <div className="footer-divider"></div>
          <p>
            <div className="footer-links">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                size="lg"
                color="#33B9CB"
              />{" "}
              <p>{config.location_1}</p>
            </div>
          </p>
          <p>
            <a
              href={`tel:${config.number_1}`}
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "inline-flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <div className="footer-links">
                <FontAwesomeIcon icon={faPhone} size="lg" color="#33B9CB" />
                <p>{config.number_1}</p>
              </div>
            </a>
          </p>
          <p>
            <div className="footer-links">
              <FontAwesomeIcon icon={faEnvelope} size="lg" color="#33B9CB" />
              <p>{config.email}</p>
            </div>
          </p>
        </div>
        <div className="footer-section" style={{ backgroundColor: "#1A2C4B" }}>
          <h3>Useful Link</h3>
          <div className="footer-divider"></div>
          <ul>
            <li>
              <a
                href="/More#tabs-section"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" /> 3
                  Simple Steps
                </div>
              </a>
            </li>
            <li>
              <a
                href="/More#aligner-specs"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />
                  Invisalign Specs
                </div>
              </a>
            </li>
            <li>
              <a
                href="/Results#care-section"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />{" "}
                  Care Instructions
                </div>
              </a>
            </li>
            <li>
              <a
                href="/Results#tips-section"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />{" "}
                  General Tips
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Social Media</h3>
          <div className="footer-divider"></div>
          <ul>
            <li>
              <a
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
                href={`https://wa.me/${cleanedNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />
                  WhatsApp
                </div>
              </a>
            </li>
            <li>
              <a
                href={`${config.facebook_1}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />{" "}
                  Facebook
                </div>
              </a>
            </li>
            <li>
              <a
                href={config.insta_1}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />{" "}
                  Instagram
                </div>
              </a>
            </li>
            <li>
              <a
                href={`https://linkedin.com/in/dr-maan-abadi-5a3a5283`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />{" "}
                  Linkedin
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section" style={{ backgroundColor: "#1A2C4B" }}>
          <h3>Guarantee</h3>
          <div className="footer-divider"></div>
          <ul>
            <li>
              <a
                href="/FAQS?focus=warranty"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div className="footer-links">
                  <FontAwesomeIcon icon={faStop} size="2xs" color="#707070" />{" "}
                  Warranty
                </div>
              </a>
            </li>
          </ul>
        </div>
      </footer>
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <a href="#home" className="footer-logo">
              <img
                src={logowhite}
                alt=""
                style={{
                  // width: "4.5rem",
                  // height: "4.5rem",
                  width: "15rem",
                  height: "7.5rem",
                  marginRight: "1rem",
                }}
              />
              {/* Health
              <span
                style={{
                  color: "#33B9CB",
                }}
              >
                Flow
              </span> */}
            </a>
          </div>
          <p>© HealthFlow 2025 | All rights reserved.</p>
          <div className="footer-social">
            <div className="social-circle">
              <a
                href={`https://wa.me/${cleanedNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  style={{
                    fontSize: "2.8rem",
                  }}
                />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={`${config.facebook_1}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <FontAwesomeIcon icon={faFacebookF} size="2x" />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={config.insta_1}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  style={{
                    fontSize: "2.5rem",
                  }}
                />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={`https://linkedin.com/in/dr-maan-abadi-5a3a5283`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedinIn} size="2x" />
              </a>
            </div>
            <div className="social-circle">
              <a
                href={`${config.healthflow}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={logogrey}
                  className="white-filter"
                  alt=""
                  style={{
                    width: "2.9rem",
                    height: "2.9rem",
                    cursor: "pointer",
                  }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
